import type { RootState } from 'src/redux/store';

import { useState, useEffect } from 'react';

import { useRouter } from 'src/routes/hooks';

import { useAppSelector } from 'src/hook/hooks';
import { getPostLoginRedirectPath } from 'src/permissions/post-login-redirect';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: React.ReactNode;
};

export function GuestGuard({ children }: GuestGuardProps) {
  const { loading, authenticated } = useAuthContext();
  const router = useRouter();

  const { loginApiData } = useAppSelector((state) => (state as RootState).auth);

  // for redirecting authenticated users to the returnTo path
  // const searchParams = useSearchParams();
  // const returnTo = searchParams.get('returnTo') || CONFIG.auth.redirectPath;

  const [isChecking, setIsChecking] = useState<boolean>(true);

  const checkPermissions = async (): Promise<void> => {
    if (loading) {
      return;
    }

    if (authenticated) {
      const target = getPostLoginRedirectPath(loginApiData);
      router.replace(target);
      return;
    }

    setIsChecking(false);
  };

  useEffect(() => {
    checkPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, loading, loginApiData]);

  if (isChecking) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
